import styled from 'styled-components';

export const MaintenanceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: white;
  font-family: Arial, sans-serif;
  padding: 20px;
`;

export const MaintenanceBox = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);;
  padding: 50px 40px;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 800px;
  width: 90%;
  text-align: left;
`;

export const Icon = styled.div`
  font-size: 80px;
  margin-bottom: 20px;
`;

export const LogoContainer = styled.div`
  display: table;
  margin: 0 auto 25px;
`;

export const Title = styled.h1`
  font-size: 26px;
  margin-bottom: 15px;
  color: #fff;
`;

export const FinePrint = styled.span`
  font-size: 16px;
  font-style: italic;
`;

export const Message = styled.p`
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
`;

export const Footer = styled.p`
  margin-top: 30px;
  font-size: 14px;
  color: #999;
`;